<template>
  <div>
    传输transfer
  </div>
</template>

<script>
export default {
  name: "transfer",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>